import { render, staticRenderFns } from "./YouTubeBlock.vue?vue&type=template&id=27dd3298&scoped=true&"
import script from "./YouTubeBlock.vue?vue&type=script&lang=ts&"
export * from "./YouTubeBlock.vue?vue&type=script&lang=ts&"
import style0 from "./YouTubeBlock.vue?vue&type=style&index=0&id=27dd3298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd3298",
  null
  
)

export default component.exports